import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@mui/material';
import QuadPanel from 'features/IRWorkstation/components/QuadPanel';
import AlertsRow from 'features/IRWorkstation/components/AlertsRow';

const AlertsWidget = ({ onOpenAlertsDrawer, alerts, loading, error }) => {
	const AlertList = () =>
		alerts.map((alert) => (
			<AlertsRow
				key={`alert-${alert.id}`}
				alert={alert}
				onClick={alert ? () => onOpenAlertsDrawer(alert) : undefined}
			/>
		));

	const LoadingIndicator = () => (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				padding: '40px',
				flexDirection: 'column',
				gap: 2,
				height: '100%',
			}}
		>
			<CircularProgress size={18} />
			<Typography variant='body2' color='text.secondary'>
				Loading alerts...
			</Typography>
		</Box>
	);

	const ErrorMessage = () => (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				padding: '40px',
				height: '100%',
			}}
		>
			<Typography variant='body2' color='error'>
				{error}
			</Typography>
		</Box>
	);

	const EmptyState = () => (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				padding: '40px',
				height: '100%',
			}}
		>
			<Typography variant='body2' color='text.secondary'>
				No Alerts.
			</Typography>
		</Box>
	);

	return (
		<QuadPanel
			title='Alerts'
			badge={`${alerts.length} unacknowledged`}
			badgeColor='red'
		>
			{loading ? (
				<LoadingIndicator />
			) : error ? (
				<ErrorMessage />
			) : alerts.length === 0 ? (
				<EmptyState />
			) : (
				<AlertList />
			)}
		</QuadPanel>
	);
};

AlertsWidget.propTypes = {
	onOpenAlertsDrawer: PropTypes.func.isRequired,
	alerts: PropTypes.array.isRequired,
	loading: PropTypes.bool.isRequired,
	error: PropTypes.string,
};

export default AlertsWidget;
